import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "impx-slide-container hp3 uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom uk-background-fixed uk-background-center-center uk-height-1-1" }
const _hoisted_2 = { class: "uk-container uk-margin-top impx-margin-top-small" }

import EventActivitiesCaroussel from "@/views/event-activities/components/EventActivitiesCaroussel.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EventHeading',
  props: {
      carouselItems:[]
    },
  setup(__props) {

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "impx-overlay dark" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(EventActivitiesCaroussel, {
        "carrousel-element": props.carouselItems
      }, null, 8, ["carrousel-element"])
    ])
  ]))
}
}

})